import { FC } from 'react'
import { Button, Stack } from '@mui/material'
import i18n from 'lib/i18'
import { useTranslation } from 'react-i18next'
import { Language as GlobeIcon } from '@mui/icons-material'
import { ReactComponent as MainLogo } from 'assets/images/logo.svg'
import { ReactComponent as SectionLogo } from 'assets/images/landingPageLogo.svg'
import IconDropdown from 'components/IconDropdown/IconDropdown'
import { useAuth } from 'providers/AuthProvider'
import { useLocale } from 'providers/LocaleProvider'
import {
  MainWrapper,
  HeadSectionWrapper,
  ContentSectionWrapper,
  ContentWrapper,
  Title,
  LanguageMenuItem,
  ImageWrapper,
  MainHeading,
  CaptionText,
  FooterContent,
} from './Login.styled'
import languageOptions from '../../lib/languages'

const Login: FC = () => {
  const currentYear = new Date().getFullYear()
  const { t } = useTranslation()

  const { handleLogin } = useAuth()
  const { changeLangFormat, handleLanguageChange } = useLocale()

  const availableLanguageOptions = languageOptions.map((language) => {
    return { label: t(language.label), value: language.value }
  })

  const handleLanguage = (selectedValue: string) => {
    handleLanguageChange(selectedValue, availableLanguageOptions)
  }

  return (
    <MainWrapper container>
      <ContentSectionWrapper item md={6} lg={5}>
        <header>
          <HeadSectionWrapper direction='row' justifyContent='space-between'>
            <Stack direction='row' alignItems='center' gap={2}>
              <MainLogo aria-hidden='true' />
              <Title variant='h6'>Naveo Commerce</Title>
            </Stack>
            <IconDropdown
              minWidth='150px'
              expandIconRequired
              Icon={GlobeIcon}
              optionItem={changeLangFormat(
                i18n.language,
                availableLanguageOptions
              )}
              ariaLabel={t('languageSelection-Aria')}
              options={availableLanguageOptions}
              onChange={handleLanguage}
              renderOption={(option) => (
                <LanguageMenuItem
                  key={option.value}
                  value={option.value}
                  role='option'>
                  {option.label}
                </LanguageMenuItem>
              )}
            />
          </HeadSectionWrapper>
        </header>
        <main>
          <ContentWrapper>
            <Stack gap={1}>
              <MainHeading variant='h1'>{t('welcome')}</MainHeading>
              <CaptionText variant='body1'>{t('welcomeMessage')}</CaptionText>
              <Button variant='contained' onClick={handleLogin}>
                {t('signInButton')}
              </Button>
            </Stack>
          </ContentWrapper>
        </main>
        <footer>
          <FooterContent>Naveo Commerce Ltd. © {currentYear}</FooterContent>
        </footer>
      </ContentSectionWrapper>
      <ImageWrapper item md={6} lg={7}>
        <SectionLogo width='100%' height='100%' />
      </ImageWrapper>
    </MainWrapper>
  )
}

export default Login
